import { NaturezaAnalise } from "@/@types/NaturezaAnalise";
import { SelectOption } from "@/@types/SelectOption";
import { IEnsaioAnalise } from "@/interfaces/IEnsaioAnalise";
import { api } from "@/services/api";
import { ensaioAnaliseAction } from "@/store/actions/ensaioAnalise";
import { getEnsaiosAnaliseSynced } from "@/store/reducers/ensaioAnalise";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useEnsaiosAnalise = () => {
  const { user } = useAuth();
  const listaEnsaios = useSelector(getEnsaiosAnaliseSynced);
  const appDispatch = useDispatch();
  const { sync } = ensaioAnaliseAction;
  const [ensaioOptions, setEnsaioOptions] = useState<SelectOption[]>([]);

  const sincronizarEnsaios = (ensaios: IEnsaioAnalise[]) => {
    appDispatch(sync(ensaios));
  };

  const getEnsaiosApi = async () => {
    const { data } = await api.get<IEnsaioAnalise[]>(`/ensaios-analise/todos`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const getEnsaiosByNatureza = (natureza: NaturezaAnalise) => {
    const ensaios = listaEnsaios.filter(
      (ensaio) => ensaio.naturezaAnalise === natureza
    );
    const options = ensaios.map((ensaio) => ({
      label: `${ensaio.nome.toUpperCase()} - ${ensaio.codigo}`,
      value: ensaio.id,
    }));
    setEnsaioOptions(options);
  };

  return {
    listaEnsaios,
    sincronizarEnsaios,
    getEnsaiosApi,
    ensaioOptions,
    getEnsaiosByNatureza,
  };
};
